import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import clickIcon from "./../../media/orange-sort-icon.svg";
import "../../styleSheet/main/components/TODO/forTODO/forTODO.css";
import searchIcon from "./../../media/search-icon.svg";
import ButtonDelete from "./../../media/delete-button.svg";
import CreateForTODO from "./createForTODO.js";
import DirectionIcon from "./../../media/direction-icon.svg";
import DirectionIconOrange from "./../../media/orange-sort-icon.svg";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { pl } from "date-fns/locale";
import HistoryForTODO from "./historyForTODO";
import httpClient from "../../services/httpClient";

const ForTODO = () => {
  const { t } = useTranslation();
  const [tasksData, setTasksData] = useState({});
  const [userIdMap, setUserIdMap] = useState({}); // Mapowanie nazwa -> userId
  const [selectedManager, setSelectedManager] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [editingTask, setEditingTask] = useState(null);
  const [originalTaskText, setOriginalTaskText] = useState("");
  const [showEditModal, setShowEditModal] = useState(false);
  const [isCreatingTask, setIsCreatingTask] = useState(false);
  const [isHistoryMode, setIsHistoryMode] = useState(false);
  const [hover, setHover] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSubordinates = async () => {
      try {
        const response = await httpClient.get("/Users/subordinates", {
          withAuth: true,
        });
        const subordinates = response.data;
        console.log("Raw subordinates data:", subordinates);

        // Transform the fetched data into the required structure
        const transformedData = subordinates.reduce((acc, subordinate) => {
          const fullName = `${subordinate.firstName} ${subordinate.lastName}`;
          acc[fullName] = [];
          console.log("Creating key:", fullName, "with id:", subordinate.id);
          return acc;
        }, {});

        // Create mapping from name to userId (using 'id' field from API)
        const nameToUserIdMap = subordinates.reduce((acc, subordinate) => {
          const fullName = `${subordinate.firstName} ${subordinate.lastName}`;
          acc[fullName] = subordinate.id; // Changed from subordinate.userId to subordinate.id
          console.log(`Mapping: "${fullName}" -> "${subordinate.id}"`);
          return acc;
        }, {});

        console.log("Final userIdMap:", nameToUserIdMap);
        console.log("Keys in userIdMap:", Object.keys(nameToUserIdMap));
        setTasksData(transformedData);
        setUserIdMap(nameToUserIdMap);
      } catch (err) {
        setError(t("todo.fetchSubordinatesError"));
      } finally {
        setIsLoading(false);
      }
    };

    fetchSubordinates();
  }, []);

  useEffect(() => {
    if (!isLoading) {
      localStorage.setItem("tasksData", JSON.stringify(tasksData));
    }
  }, [tasksData, isLoading]);

  const handleCreateTaskClick = () => {
    console.log("handleCreateTaskClick - selectedManager:", selectedManager);
    console.log("handleCreateTaskClick - userIdMap:", userIdMap);
    console.log(
      "handleCreateTaskClick - userId for selected:",
      userIdMap[selectedManager],
    );
    setIsCreatingTask(true);
  };

  const handleManagerClick = (name) => {
    setSelectedManager(name);
    setIsHistoryMode(false);
  };

  const handleBackClick = () => {
    setSelectedManager(null);
    setIsHistoryMode(false);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleViewHistory = () => {
    setIsHistoryMode(true); // Przełącza tryb na historię
  };

  const handleExitHistory = () => {
    setIsHistoryMode(false); // Powrót z historii do listy zadań
  };

  const getOverdueCount = (tasks) => {
    const today = new Date();
    return tasks.filter(
      (task) =>
        new Date(task.date) < today &&
        new Date(task.date).toDateString() !== today.toDateString(),
    ).length;
  };

  const getFirstName = (fullName) => {
    return fullName.split(" ")[0];
  };

  const sortTasks = (tasks) => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    const pastTasks = tasks.filter(
      (task) =>
        new Date(task.date) < today &&
        new Date(task.date).toDateString() !== today.toDateString(),
    );
    const todayTasks = tasks.filter(
      (task) => new Date(task.date).toDateString() === today.toDateString(),
    );
    const tomorrowTasks = tasks.filter(
      (task) => new Date(task.date).toDateString() === tomorrow.toDateString(),
    );
    const futureTasks = tasks.filter((task) => new Date(task.date) > tomorrow);

    return {
      pastTasks: pastTasks.sort((a, b) => new Date(b.date) - new Date(a.date)),
      todayTasks,
      tomorrowTasks,
      futureTasks: futureTasks.sort(
        (a, b) => new Date(a.date) - new Date(b.date),
      ),
    };
  };

  const formatDate = (date) => {
    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    return new Date(date).toLocaleDateString("pl-PL", options);
  };

  const openEditModal = (task) => {
    setEditingTask({ ...task });
    setOriginalTaskText(task.text);
    setShowEditModal(true);
  };

  const closeEditModal = () => {
    setShowEditModal(false);
    setEditingTask(null);
    setOriginalTaskText("");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditingTask((prevTask) => ({
      ...prevTask,
      [name]: value,
    }));
  };

  const handleCreateNewTask = (newTask) => {
    const updatedTasks = [...tasksData[selectedManager], newTask];
    setTasksData((prevData) => ({
      ...prevData,
      [selectedManager]: updatedTasks,
    }));
    setIsCreatingTask(false);
  };

  const handleCancelNewTask = () => {
    setIsCreatingTask(false);
  };

  const handleSave = async () => {
    try {
      const userId = userIdMap[selectedManager];
      if (!userId) {
        console.error("userId not found for:", selectedManager);
        return;
      }

      if (!editingTask.id) {
        console.error("Task ID is missing:", editingTask);
        setError(t("todo.errorMissingId"));
        return;
      }

      // Prepare data for API
      const taskUpdateData = {
        title: editingTask.text,
        dueDate: editingTask.date,
      };

      console.log(
        "Updating task:",
        editingTask.id,
        "with data:",
        taskUpdateData,
      );

      // Send PUT request to update the task
      const response = await httpClient.put(
        `/ToDoTasks/${editingTask.id}`,
        taskUpdateData,
        { withAuth: true },
      );

      console.log("Task updated successfully:", response.data);

      // Update local state
      const updatedTasks = tasksData[selectedManager].map((task) =>
        task.id === editingTask.id ? { ...editingTask } : task,
      );

      setTasksData((prevData) => ({
        ...prevData,
        [selectedManager]: updatedTasks,
      }));

      closeEditModal();
    } catch (error) {
      console.error("Error updating task:", error);
      console.error("Error response:", error.response?.data);

      // Handle both object and array error formats
      if (Array.isArray(error.response?.data)) {
        console.error("Error array:", error.response.data);
        error.response.data.forEach((err, index) => {
          console.error(`Error ${index}:`, err);
        });
      } else {
        console.error("Validation errors:", error.response?.data?.errors);
      }

      console.error("Error status:", error.response?.status);
      console.error("Error details:", error.response);
      setError(t("todo.updateTaskError"));
    }
  };

  const renderEditModal = () => (
    <div className="modal-overlay">
      <div className="modal-content-TODO">
        <img
          src={ButtonDelete}
          className="close-button-TODO"
          onClick={closeEditModal}
          alt="Close"
        />
        <p>Edytuj zadanie :</p>
        <div className="form-group">
          <div className="left">
            <div className="think">Treść :</div>
          </div>
          <input
            type="text"
            name="text"
            value={editingTask ? editingTask.text : ""}
            onChange={handleInputChange}
          />
        </div>
        <div className="form-group">
          <div className="left">
            <div className="think">Data :</div>
          </div>
          <DatePicker
            selected={editingTask?.date ? new Date(editingTask.date) : null}
            onChange={(date) =>
              setEditingTask((prevTask) => ({
                ...prevTask,
                date: date.toISOString().slice(0, 10), // Konwersja daty na format "yyyy-mm-dd"
              }))
            }
            dateFormat="dd-MM-yyyy"
            locale={pl}
            minDate={new Date()}
            className="custom-datepicker"
          />
        </div>
        <div className="modal-buttons">
          <button className="save-button" onClick={handleSave}>
            Zapisz zmiany
          </button>
        </div>
      </div>
    </div>
  );

  useEffect(() => {
    const fetchTasksForSubordinates = async () => {
      try {
        setIsLoading(true);
        const userId = userIdMap[selectedManager];
        console.log(
          "Fetching tasks for:",
          selectedManager,
          "with userId:",
          userId,
        );
        if (!userId) {
          console.error("userId not found for:", selectedManager);
          return;
        }
        const response = await httpClient.get(
          `/ToDoTasks/assigned-by-me/to-user/${userId}`,
          { withAuth: true },
        );
        console.log("Tasks response:", response.data);
        console.log("Number of tasks:", response.data?.length);
        console.log("First task structure:", response.data[0]);
        console.log(
          "Task fields:",
          response.data[0] ? Object.keys(response.data[0]) : "no tasks",
        );

        // Map API response to expected format
        const mappedTasks = response.data.map((task) => ({
          ...task,
          text: task.title || task.text, // Use title from API, fallback to text
          date: task.dueDate || task.date, // Use dueDate from API, fallback to date
        }));

        console.log("Mapped tasks:", mappedTasks);

        setTasksData((prevData) => ({
          ...prevData,
          [selectedManager]: mappedTasks,
        }));
      } catch (err) {
        console.error("Error fetching tasks:", err);
        setError("Nie udało się pobrać zadań dla podopiecznych.");
      } finally {
        setIsLoading(false);
      }
    };

    if (selectedManager) {
      fetchTasksForSubordinates();
    }
  }, [selectedManager, userIdMap]);

  if (selectedManager) {
    const tasks = tasksData[selectedManager] || [];
    console.log("Rendering tasks for:", selectedManager);
    console.log("Tasks data:", tasks);
    console.log("Is array?", Array.isArray(tasks));
    const sortedTasks = sortTasks(tasks);

    return (
      <>
        <div className="manager-todo-container">
          {!isHistoryMode && (
            <div className="todo-for">
              <p>{selectedManager}</p>
            </div>
          )}
          <img
            src={clickIcon}
            alt={t("todo.backToList")}
            className="back-icon"
            onClick={handleBackClick}
          />

          {!isHistoryMode ? ( // Wyświetl TODO lub historię na podstawie isHistoryMode
            <>
              {tasks.length === 0 ? (
                <div className="not-yet">
                  <p className="no-tasks">
                    {t("todo.noTasksForManager", { name: selectedManager })}
                  </p>
                </div>
              ) : (
                <ul className="tasks">
                  {sortedTasks.pastTasks.length > 0 && (
                    <>
                      <strong style={{ color: "red" }}>
                        {formatDate(sortedTasks.pastTasks[0].date)} :
                      </strong>
                      {sortedTasks.pastTasks.map((task, index) => (
                        <li
                          key={index}
                          className="task-item"
                          onClick={() => openEditModal(task)}
                        >
                          <span className="task-square"></span>
                          <span className="task-text">{task.text}</span>
                        </li>
                      ))}
                    </>
                  )}
                  {sortedTasks.todayTasks.length > 0 && (
                    <>
                      <strong>na dzisiaj :</strong>
                      {sortedTasks.todayTasks.map((task, index) => (
                        <li
                          key={index}
                          className="task-item"
                          onClick={() => openEditModal(task)}
                        >
                          <span className="task-square"></span>
                          <span className="task-text">{task.text}</span>
                        </li>
                      ))}
                    </>
                  )}
                  {sortedTasks.tomorrowTasks.length > 0 && (
                    <>
                      <strong>na jutro :</strong>
                      {sortedTasks.tomorrowTasks.map((task, index) => (
                        <li
                          key={index}
                          className="task-item"
                          onClick={() => openEditModal(task)}
                        >
                          <span className="task-square"></span>
                          <span className="task-text">{task.text}</span>
                        </li>
                      ))}
                    </>
                  )}
                  {sortedTasks.futureTasks.length > 0 && (
                    <>
                      {sortedTasks.futureTasks.map((task, index, arr) => {
                        const taskDate = formatDate(task.date);
                        const previousTaskDate =
                          index > 0 ? formatDate(arr[index - 1].date) : null;

                        return (
                          <React.Fragment key={index}>
                            {taskDate !== previousTaskDate && (
                              <strong>{taskDate} :</strong>
                            )}
                            <li
                              className="task-item"
                              onClick={() => openEditModal(task)}
                            >
                              <span className="task-square"></span>
                              <span className="task-text">{task.text}</span>
                            </li>
                          </React.Fragment>
                        );
                      })}
                    </>
                  )}
                </ul>
              )}
              <div className="header-buttons">
                <button
                  className="booking-button"
                  onMouseEnter={() => setHover(true)}
                  onMouseLeave={() => setHover(false)}
                  onClick={handleViewHistory}
                >
                  <div
                    className="icon"
                    style={{
                      backgroundImage: `url(${
                        hover ? DirectionIconOrange : DirectionIcon
                      })`,
                      transform: hover ? "scale(1.2)" : "rotate(270deg)",
                    }}
                  ></div>
                  {t("todo.history")}
                </button>
              </div>
              {!isHistoryMode && ( // Tylko wyświetl przycisk tworzenia zadania, gdy nie jesteś w trybie historii
                <div className="creating">
                  <button
                    onClick={handleCreateTaskClick}
                    className="create-button"
                  >
                    {t("todo.createTaskFor", {
                      name: getFirstName(selectedManager),
                    })}
                  </button>
                </div>
              )}
            </>
          ) : (
            <>
              <HistoryForTODO
                userId={userIdMap[selectedManager]}
                completedTasks={tasks}
              />
              <div className="creating">
                <button onClick={handleExitHistory} className="create-button">
                  {t("todo.backToTodoFor", {
                    name: getFirstName(selectedManager),
                  })}
                </button>
              </div>
            </>
          )}
        </div>

        {isCreatingTask && (
          <div className="create-task-overlay">
            <CreateForTODO
              onClose={handleCancelNewTask}
              onCreate={handleCreateNewTask}
              userName={selectedManager}
              userId={userIdMap[selectedManager]}
            />
          </div>
        )}

        {showEditModal && renderEditModal()}
      </>
    );
  }

  console.log("Current tasksData:", tasksData);
  console.log("Current userIdMap:", userIdMap);

  const managers = Object.keys(tasksData).map((name) => ({
    name,
    overdueCount: 0, // Placeholder for overdue count logic
  }));

  const filteredManagers = managers.filter((manager) =>
    manager.name.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  return (
    <div className="manager-todo-container">
      <p>{t("todo.todoForSubordinates")}</p>

      <div className="searching">
        <input
          type="text"
          placeholder={t("todo.searchPlaceholder")}
          value={searchTerm}
          onChange={handleSearchChange}
          className="search-input"
        />
        <div
          className="search-icon"
          style={{ backgroundImage: `url(${searchIcon})` }}
          onClick={() => {}}
        ></div>
      </div>

      <ul className="manager-list">
        {filteredManagers.length > 0 ? (
          filteredManagers.map((manager, index) => (
            <li
              className="manager-item"
              key={index}
              onClick={() => handleManagerClick(manager.name)}
            >
              <img src={clickIcon} alt="Ikona" className="manager-icon" />
              <span>{manager.name}</span>
            </li>
          ))
        ) : (
          <p>{t("todo.noResultsFor", { term: searchTerm })}</p>
        )}
      </ul>
    </div>
  );
};

export default ForTODO;
